import { render, staticRenderFns } from "./NextSection.vue?vue&type=template&id=3b772c5c"
import script from "./NextSection.vue?vue&type=script&lang=js"
export * from "./NextSection.vue?vue&type=script&lang=js"
import style0 from "./NextSection.vue?vue&type=style&index=0&id=3b772c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports